import { Button } from "../components/Button";
import { cn } from "../lib/utils";
import * as React from "react";
/**
 * An empty-state placeholder that explains why a region has no content and
 * offers a way forward via an action slot. Use it when a list, table, or
 * section has no data yet and you want to guide the user toward populating
 * it; for a transient loading placeholder, use a LoadingBlock skeleton
 * instead.
 * @summary Empty-state placeholder with call to action.
 */
const EmptyCTA = React.forwardRef(({
  action,
  title,
  message,
  styleProps,
  className,
  ...props
}, ref) => /*#__PURE__*/React.createElement("div", {
  ref: ref,
  className: cn("flex w-full flex-col items-center justify-center gap-2 rounded-xl p-12", "border border-border bg-muted-background", className),
  style: styleProps,
  ...props
}, title && /*#__PURE__*/React.createElement("div", {
  className: cn("text-center text-sm font-medium", "text-foreground")
}, title), message && /*#__PURE__*/React.createElement("div", {
  className: cn("text-center text-sm", "text-muted-foreground")
}, message), /*#__PURE__*/React.createElement("div", null, action)));
EmptyCTA.displayName = "EmptyCTA";
/** Highlight-variant Button preset for the primary action of an EmptyCTA. */
const EmptyCTAButton = ({
  icon,
  label,
  variant = "highlight",
  ...props
}) => /*#__PURE__*/React.createElement(Button, {
  icon: icon,
  label: label,
  variant: variant,
  ...props
});
EmptyCTAButton.displayName = "EmptyCTAButton";
export { EmptyCTA, EmptyCTAButton };
//# sourceMappingURL=EmptyCTA.js.map